import { AnimalCounter } from '../animal/animalClass';
import LandInterface from './landInterface';
import OwnerClass from '../ownership/ownerClass';
import UserClass from '../user/userClass';

export class RoleClass {
    id: string;
    land: LandClass;
    logguedId: string;

    constructor(land: LandClass, logged: Record<string, string>) {
        this.land = land;
        this.logguedId = logged.uid;
    }

    getId() {
        let result = this.id;
        if (!result) {
            if (this.land.owner === this.logguedId) {
                result = 'owner';
            } else if (this.land.editors.includes(this.logguedId)) {
                result = 'editor';
            } else if (this.land.readers.includes(this.logguedId)) {
                result = 'reader';
            }
            this.id = result;
        }
        return result;
    }

    isOwner() {
        return this.getId() === 'owner';
    }
    isEditor() {
        return this.getId() === 'editor';
    }
    isReader() {
        return this.getId() === 'reader';
    }
}

export default class LandClass extends OwnerClass implements LandInterface {
    animals: AnimalCounter[];
    location: string;
    map: {
        type: 'simple' | 'carto' | 'custom';
        data: string;
        lat?: number;
        lng?: number;
    };
    name: string;
    size: number;
    readers: string[] = [];
    readersUser: UserClass[] = [];
    editors: string[] = [];
    editorsUser: UserClass[] = [];
    owner: string;
    ownerUser: UserClass;

    constructor(data: LandInterface) {
        super({ ...data });
        this.animals = (data.animals || []).map(
            (a) => new AnimalCounter(a.amount, a)
        );
        this.editors = data.editors || [];
        this.location = data.location;
        this.map = data.map;
        this.name = data.name;
        this.owner = data.owner || this.logged.uid;
        this.readers = data.readers || [];
        this.size = data.size;
    }

    getDefaultImage(): string {
        return '/images/lands/land.jpg';
    }

    getDefaultMap(): string {
        return 'https://www.google.com/maps/d/u/0/embed?mid=1nUFhW37GSKhw9OdbJlHaquPf_nb6fqU&ehbc=2E312F';
    }

    // getMap() {
    //     return this.map || this.getDefaultMap();
    // }

    getLoggedRole(item?: LandClass): RoleClass {
        return new RoleClass(this, this.logged);
    }

    countAnimalsBySpecie(): AnimalCounter[] {
        const result = this.animals
            .filter((a) => a.amount > 0)
            .reduce((acc, ani) => {
                acc[ani.specie]
                    ? acc[ani.specie].add(ani.amount)
                    : (acc[ani.specie] = new AnimalCounter(ani.amount, {
                          specie: ani.specie
                      }));
                return acc;
            }, {});
        return Object.values(result);
    }

    toJSON(): Record<string, any> {
        var json = super.toJSON();
        return {
            id: this.id,
            data: {
                ...json.data,
                animals: this.animals.length
                    ? this.animals.map((a) => a.toJSON())
                    : undefined,
                editors: this.editors.length ? this.editors : undefined,
                location: this.location,
                map: this.map,
                name: this.name,
                readers: this.readers.length ? this.readers : undefined,
                owner: this.owner,
                size: this.size
            }
        };
    }
}
